import React from 'react';
import Container from './Container';
import CtaLink from './CtaLink';

const ContactInquiry = () => {
  return (
    <section className="section contact-inquiry" id="inquiry">
      <Container>
        <div className="inquiry-grid">
          <div className="inquiry-left">
            <div className="container section-badge flex items-center gap-3 text-[16px] md:text-[20px] !px-1">
              <div className="badge-dot"></div>
              Customer Inquiry
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">How Can We<br />Help You ?</h2>
            <div className="inquiry-visual">
              <img src="/images/contact_us_container.webp" alt="Container" />
            </div>
          </div>
          <div className="inquiry-right">
            <div className="card inquiry-card">
              <div className='flex flex-col justify-center self-center text-center'>
                <h3 className="text-lg md:text-xl lg:text-2xl">Send Us Message</h3>
                <p className="muted text-sm md:text-base">Your email address will not be published. Required fields are marked*</p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ContactInquiry;

const ContactForm = () => {
  const [form, setForm] = React.useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitting, setSubmitting] = React.useState(false);
  const [status, setStatus] = React.useState(null);
  const [toast, setToast] = React.useState(null); // { type: 'success' | 'error', message: string }
  const toastTimerRef = React.useRef(null);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setStatus(null);
    try {
      const res = await fetch('https://timelineexpress.in/backend/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to submit');
      }
      setStatus({ type: 'success', message: 'Message sent successfully.' });
      showToast({ type: 'success', title: 'Success', message: 'Your message has been sent. We\'ll get back to you shortly.' });
      setForm({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (err) {
      const isNetwork = /network/i.test(err?.message || '');
      const msg = isNetwork
        ? 'Network error. Please check your connection and try again.'
        : (err?.message || 'Something went wrong. Please try again.');
      setStatus({ type: 'error', message: msg });
      showToast({ type: 'error', title: 'Error', message: msg });
    } finally {
      setSubmitting(false);
    }
  };

  const showToast = (t) => {
    setToast(t);
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToast(null), 3200);
  };

  React.useEffect(() => () => {
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
  }, []);

  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <div className="row">
        <input name="name" value={form.name} onChange={onChange} type="text" placeholder="Your name" required />
        <input name="phone" value={form.phone} onChange={onChange} type="tel" placeholder="Phone Number" required />
      </div>
      <div className="row">
        <input name="email" value={form.email} onChange={onChange} type="email" placeholder="Email Address" required />
        <input name="subject" value={form.subject} onChange={onChange} type="text" placeholder="Subjects" />
      </div>
      <textarea name="message" value={form.message} onChange={onChange} rows="5" placeholder="Write message" required></textarea>
      <div className="actions" style={{ width: '100%' }}>
        <CtaLink
          href="#"
          primaryText={submitting ? 'Sending...' : 'Send Your Message'}
          ariaLabel="Submit contact form"
          onClick={(e) => {
            e.preventDefault();
            const formEl = e.currentTarget.closest('form');
            if (formEl) formEl.requestSubmit();
          }}
          fill="#000"
          hoverFill="#fff"
          fullWidth
        />
      </div>
      {status && (
        <p className={status.type === 'success' ? 'text-success' : 'text-error'} style={{ marginTop: 8 }}>
          {status.message}
        </p>
      )}

      {/* Toast Notification */}
      <div className={`toast-container ${toast ? 'is-visible' : ''}`} aria-live="polite" aria-atomic="true">
        {toast && (
          <div className={`toast ${toast.type}`} role="status">
            <span className="toast-dot" aria-hidden="true"></span>
            {toast.title && <span className="toast-title">{toast.title}</span>}
            <span className="toast-message">{toast.message}</span>
          </div>
        )}
      </div>
    </form>
  );
};
